import BordableModel from './BordableModel';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import API from '../../utils/API';
import { parseResultToJson } from '../../utils/helper';

export default class DataSourceModel extends BordableModel {

    sourceType = new PropertyDescriptor('staticData', '类型', "数据源", "enum", "#anticon-database_mixing", {
        gallery: "数据",
        galleryIndex: 20,
        values: [
            new PropertyDescriptor("staticData", '静态数据', "类型", "string"),
            new PropertyDescriptor("scriptService", '脚本服务', "类型", "string"),
            new PropertyDescriptor("dynamicQuery", '数据表', "类型", "string")
        ],
        zIndex: -1,
    });
    scriptService = new PropertyDescriptor('', '服务地址', '数据源', 'scriptService', "#anticon-link", {
        gallery: "数据",
        zIndex: 10,
        visible: false
    });
    dynamicQuery = new PropertyDescriptor('', '数据表', '数据源', 'dynamicQuery', "#anticon-link", {
        gallery: "数据",
        zIndex: 10,
        visible: false
    });
    // chartValueMap = new PropertyDescriptor('{\n\t\n}', '数据', '数据源', 'json', "#anticon-border-top");
    dataValue = new PropertyDescriptor('{\n\t\n}', '数据', '数据源', 'json', "#anticon-box1", {
        gallery: "数据",
        zIndex: 10,
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });
    isAutoRefresh = new PropertyDescriptor(false, '自动刷新', "数据源", "bool", "#anticon-shuaxin5", {
        gallery: "数据",
        zIndex: 10
    });
    autoRefreshInterval = new PropertyDescriptor(60, '间隔(秒)', "数据源", "double", "#anticon-home5", {
        gallery: "数据",
        minValue: 1,
        zIndex: 10
    });
    asyncLoading = new PropertyDescriptor(false, '加载中', "数据源", "bool", "", {
        gallery: "数据",
        enabled: false
    });

    onPropertyValueChanged(name, oldVal, newVal, subName) {
        super.onPropertyValueChanged(name, oldVal, newVal, subName);
        if (name === 'sourceType' && !subName) {
            this.setVisible();
        }
        if ((name === 'scriptService' || name === 'dynamicQuery') && !subName) {
            this.refreshData();
        }
    }
    refreshData() {
        this.asyncLoading = true;
        return new Promise(resolve => {
            let sourceType = this.sourceType;
            switch (sourceType) {
                case 'scriptService': this.getScriptData().then(() => {
                    this.asyncLoading = false;
                    resolve();
                });
                    break;
                case 'dynamicQuery': this.getDynamicQueryData().then(() => {
                    this.asyncLoading = false;
                    resolve();
                });
                    break;
                default:
                    this.asyncLoading = false;
                    resolve();
            }
        })
    }
    getScriptData() {
        return new Promise((resolve, reject) => {
            if (!this.scriptService || !this.scriptService.url) {
                this.dataValue = null;
                resolve();
                return;
            }
            let url = this.scriptService.url;
            console.log(this.scriptService);
            let params = {};
            (this.scriptService.params || []).forEach(param => {
                params[param.key] = param.value;
            });
            API.postJson(url + '/exe', {
                ...params
            }).then(baseData => {
                let data = parseResultToJson(baseData);
                this.setDataValue(data, baseData);
                resolve();
                // resolve(data);
            }).catch(e => {
                resolve();
                // resolve(null);
            })
        })

    }
    getDynamicQueryData() {
        return new Promise((resolve, reject) => {
            let item = this.dynamicQuery;
            if (!item || !item.queryValue || !item.queryItem || !item.executor) {
                this.dataValue = null;
                resolve();
                return;
            }
            API.executeExecutor(item.queryItem.dsId, item.executor, {
                sql: item.queryValue
            }).then(baseData => {
                let data = parseResultToJson(baseData);
                this.setDataValue(data, baseData);
                resolve();
            }).catch(e => {
                resolve();
            })
        });
    }
    setDataValue(data, baseData) {
        if (this.format) {
            this.format({
                data,
                baseData
            }, result => {
                this.dataValue = JSON.stringify(result, null, 2);
            });
        } else {
            this.dataValue = JSON.stringify(data, null, 2);
        }
    }
    getData() {
        // return new Promise((resolve, reject) => {
        let data = [];
        try {
            data = JSON.parse(this.dataValue);
            if (!(data instanceof Array)) {
                data = [data];
            }
        } catch (e) {

        }
        return data;
    }
    setVisible() {
        this.setPropertyVisible("dynamicQuery", this.sourceType === "dynamicQuery");
        this.setPropertyVisible("scriptService", this.sourceType === "scriptService");
    }
    toStyle() {

        return {
            ...super.toStyle(),
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontWeight: this.isBold ? 'bold' : 'normal',
            color: this.fontColor,
            display: 'flex',
            flexDirection: 'row',
            alignItems: this.verticalAlignment,
            justifyContent: this.horizontalAlignment,
            ...super.getExtendStyle(),
        }
    }
}
